import { cn } from '@/components/ui/cn'
import type { WordStatus } from '@/types/common'

const statusConfig: Record<WordStatus, { label: string; className: string }> = {
  NEW: { label: 'New', className: 'bg-slate-100 text-slate-700' },
  LEARNING: { label: 'Learning', className: 'bg-blue-100 text-blue-700' },
  REVIEW: { label: 'Review', className: 'bg-amber-100 text-amber-700' },
  MASTERED: { label: 'Mastered', className: 'bg-green-100 text-green-700' },
}

interface StatusBadgeProps {
  status: WordStatus
  className?: string
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const { label, className: colorClass } = statusConfig[status]
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        colorClass,
        className
      )}
    >
      {label}
    </span>
  )
}
